export const l10nAuditTranslations = {
  en: {
    "common.brands": "Brands",
    "common.cities": "Cities",
    "common.suppliers": "Suppliers",
    "common.support": "Support",
    "common.available": "Available",
    "common.booking": "Booking",
    "common.payment": "Payment",
    "common.confirmation": "Confirmation",
    "common.details": "Details",
    "common.extras": "Extras",
    "common.back": "Back",
    "common.previous": "Previous",
    "common.next": "Next",
    "common.close": "Close",
    "common.verified": "Verified",
    "common.contactSupplier": "Contact Supplier",
    "common.securePayment": "Secure Payment",
    "common.refreshingPricing": "Refreshing pricing...",
    "common.securityDeposit": "Security Deposit",
    "common.pickup": "Pickup",
    "common.return": "Return",
    "common.uae": "UAE",
    "accessibility.zoomOut": "Zoom Out",
    "accessibility.zoomIn": "Zoom In",
    "accessibility.switchToLightMode": "Switch to light mode",
    "accessibility.switchToDarkMode": "Switch to dark mode",
    "accessibility.logoAlt": "Velaris Royal Car Rental",
    "accessibility.locationMap": "Velaris Royal Location",
    "accessibility.breadcrumb": "Breadcrumb",
    "accessibility.previousSlide": "Previous slide",
    "accessibility.nextSlide": "Next slide",
    "accessibility.pagination": "Pagination",
    "accessibility.previousPage": "Go to previous page",
    "accessibility.nextPage": "Go to next page",
    "accessibility.morePages": "More pages",
    "accessibility.more": "More",
    "search.term.luxurySuv": "Luxury SUV",
    "search.term.sportsCar": "Sports Car",
    "search.term.dubaiMarinaRentals": "Dubai Marina Rentals",
    "search.term.weddingCars": "Wedding Cars",
    "search.term.monthlyRentalDeals": "Monthly Rental Deals",
    "search.term.chauffeurService": "Chauffeur Service",
    "search.type.location": "Location",
    "search.type.occasion": "Occasion",
    "search.type.offer": "Offer",
    "search.type.service": "Service",
    "categoryPage.notFound": "Category Not Found",
    "categoryPage.empty": "No {category} available at the moment. Check back soon!",
    "categoryPage.rent": "Rent {name}",
    "categoryPage.available": "Available {name}",
    "brandPage.notFound": "Brand Not Found",
    "brandPage.descriptionFallback": "Discover our premium {brand} collection for rent in UAE.",
    "brandPage.availableCars": "Available {brand} Cars",
    "brandPage.empty": "No {brand} cars available at the moment. Check back soon!",
    "cityPage.notFound": "City Not Found",
    "cityPage.rentalIn": "Car Rental in {city}",
    "cityPage.availableCarsIn": "Available Cars in {city}",
    "cityPage.empty": "No cars available in {city} at the moment. Check back soon!",
    "supplierPage.notFound": "Supplier Not Found",
    "supplierPage.whatsappPrefill": "Hi! I'm interested in renting a car from {supplier}.",
    "supplierPage.feature.airportTransfer": "Airport Transfer",
    "supplierPage.feature.flexiblePayment": "Flexible Payment Options",
    "supplierPage.feature.multiLanguageSupport": "Multi-language Support",
    "supplierPage.descriptionFallback": "Premium car rental service in {city}.",
    "supplierPage.reviewCount": "({count} reviews)",
    "supplierPage.carsFrom": "Cars from {supplier}",
    "supplierPage.empty": "No cars listed by this supplier at the moment.",
    "booking.step.details": "Details",
    "booking.step.extras": "Extras",
    "booking.step.payment": "Payment",
    "booking.step.confirmation": "Confirmation",
    "booking.loadCarError": "Failed to load car details",
    "booking.failed": "Failed to create booking",
    "booking.selectPickupReturn": "Please select pickup and return dates",
    "booking.fillContactDetails": "Please fill in all contact details",
    "booking.loginRequired": "Please login to complete booking",
    "booking.createdSuccess": "Booking created successfully!",
    "booking.notFound": "Car Not Found",
    "booking.bookYour": "Book Your {car}",
    "booking.detailsTitle": "Booking Details",
    "booking.pickupDateTime": "Pickup Date & Time",
    "booking.returnDateTime": "Return Date & Time",
    "booking.pickupLocation": "Pickup Location",
    "booking.returnLocation": "Return Location",
    "booking.pickupLocationPlaceholder": "Hotel, Airport, etc.",
    "booking.returnLocationPlaceholder": "Same as pickup",
    "booking.contactInformation": "Contact Information",
    "booking.fullName": "Full Name",
    "booking.phone": "Phone",
    "booking.driverAge": "Driver Age",
    "booking.driverAgePlaceholder": "Minimum 25",
    "booking.continueToExtras": "Continue to Extras",
    "booking.optionalExtras": "Optional Extras",
    "booking.extraDriver": "Extra Driver",
    "booking.extraDriverDesc": "Add an additional driver",
    "booking.childSeat": "Child Seat",
    "booking.childSeatDesc": "Baby/toddler car seat",
    "booking.gpsNavigation": "GPS Navigation",
    "booking.gpsNavigationDesc": "In-car navigation system",
    "booking.premiumInsurance": "Premium Insurance",
    "booking.premiumInsuranceDesc": "Full coverage, zero excess",
    "booking.continueToPayment": "Continue to Payment",
    "booking.loginToContinue": "Please Login to Continue",
    "booking.loginRequiredDescription": "You need to be logged in to complete your booking",
    "booking.loginRegister": "Login / Register",
    "booking.securePaymentDescription": "Your payment is processed securely. We accept all major credit and debit cards.",
    "booking.paymentPlaceholder": "Payment form will be displayed here (Stripe integration)",
    "booking.confirmAndPay": "Confirm & Pay",
    "booking.confirmedTitle": "Booking Confirmed!",
    "booking.referenceLabel": "Your booking reference is:",
    "booking.confirmationEmailSent": "A confirmation email has been sent to {email}",
    "booking.viewMyBookings": "View My Bookings",
    "booking.browseMoreCars": "Browse More Cars",
    "booking.summary": "Booking Summary",
    "booking.extrasLabel": "Extras",
    "booking.discount": "Discount",
    "booking.securityDepositNotice": "{amount} will be held on your card and refunded after return.",
    "booking.daysCount": "{count} days",
    "booking.basis.daily": "daily",
    "booking.basis.weekly": "weekly",
    "booking.basis.monthly": "monthly",
    "faq.helpCenter": "Help Center",
    "faq.metaTitle": "FAQ | Frequently Asked Questions About Car Rental",
    "faq.subtitle": "Find answers to common questions about our car rental services.",
    "faq.allQuestions": "All Questions",
    "faq.noMatch": "No questions found matching your search.",
    "faq.clearSearch": "Clear search",
    "faq.stillHaveQuestions": "Still Have Questions?",
    "faq.supportDescription": "Can't find what you're looking for? Our support team is here to help.",
    "faq.chatWhatsApp": "Chat on WhatsApp",
    "faq.category.bookingReservations": "Booking & Reservations",
    "faq.question.howBook": "How do I book a car?",
    "faq.answer.howBook": "Booking a car is easy! Simply browse our collection, select your preferred vehicle, and contact us via WhatsApp, phone, or the inquiry form.",
    "faq.question.advanceBooking": "How far in advance should I book?",
    "faq.answer.advanceBooking": "We recommend booking at least 24-48 hours in advance, especially for luxury vehicles.",
    "about.title": "About Us",
    "about.metaTitle": "About Us | UAE's Premier Luxury Car Rental Service",
    "about.storyEyebrow": "OUR STORY",
    "about.storyTitle": "Redefining Luxury Car Rental in UAE",
    "about.storySubtitle": "Since 2014, delivering exceptional car rental experiences.",
    "about.whoWeAreEyebrow": "WHO WE ARE",
    "about.legacyTitle": "A Legacy of Excellence",
    "about.legacyContent": "Velaris Royal Car Rental was founded with a vision to transform the car rental experience in the UAE. What started as a small fleet of luxury vehicles has grown into one of the region's most trusted names in premium car hire.\n\nOur commitment to excellence extends beyond just providing vehicles. We offer a complete luxury experience from the moment you browse our collection to when you return the keys.\n\nToday, we partner with over 150 premium suppliers, offering access to more than 1,200 vehicles across all emirates.",
    "about.valuesEyebrow": "OUR VALUES",
    "about.valuesTitle": "What Drives Us",
    "about.ctaTitle": "Ready to Experience Royal Service?",
    "about.heroAlt": "Luxury cars",
    "about.stat.yearsExperience": "Years Experience",
    "about.stat.premiumVehicles": "Premium Vehicles",
    "about.feature.excellence.title": "Excellence",
    "about.feature.excellence.description": "We strive for excellence in every aspect of our service.",
    "about.feature.customerFirst.title": "Customer First",
    "about.feature.customerFirst.description": "Your satisfaction is our priority.",
    "about.feature.premiumFleet.title": "Premium Fleet",
    "about.feature.premiumFleet.description": "Only the finest vehicles make it to our collection.",
    "about.feature.trustSafety.title": "Trust & Safety",
    "about.feature.trustSafety.description": "Comprehensive insurance and 24/7 support.",
    "about.storyImageAlt": "Luxury car",
    "about.yearsOfExcellence": "Years of Excellence",
    "auth.exampleEmail": "you@example.com",
    "auth.exampleName": "John Doe",
    "contact.exampleTitle": "Weekend rental question",
    "contact.locationTitle": "Velaris Royal Location",
    "footer.googlePlayAlt": "Get it on Google Play",
    "footer.appStoreAlt": "Download on App Store"
  },
  ar: {
    "common.brands": "العلامات التجارية",
    "common.cities": "المدن",
    "common.suppliers": "المورّدون",
    "common.support": "الدعم",
    "common.available": "المتاحة",
    "common.booking": "الحجز",
    "common.payment": "الدفع",
    "common.confirmation": "التأكيد",
    "common.details": "التفاصيل",
    "common.extras": "الإضافات",
    "common.back": "رجوع",
    "common.previous": "السابق",
    "common.next": "التالي",
    "common.close": "إغلاق",
    "common.verified": "موثّق",
    "common.contactSupplier": "تواصل مع المورّد",
    "common.securePayment": "دفع آمن",
    "common.refreshingPricing": "جارٍ تحديث الأسعار...",
    "common.securityDeposit": "التأمين المسترد",
    "common.pickup": "الاستلام",
    "common.return": "التسليم",
    "common.uae": "الإمارات",
    "accessibility.zoomOut": "تصغير",
    "accessibility.zoomIn": "تكبير",
    "accessibility.switchToLightMode": "التبديل إلى الوضع الفاتح",
    "accessibility.switchToDarkMode": "التبديل إلى الوضع الداكن",
    "accessibility.logoAlt": "Velaris Royal لتأجير السيارات",
    "accessibility.locationMap": "موقع Velaris Royal",
    "accessibility.breadcrumb": "مسار التنقل",
    "accessibility.previousSlide": "الشريحة السابقة",
    "accessibility.nextSlide": "الشريحة التالية",
    "accessibility.pagination": "ترقيم الصفحات",
    "accessibility.previousPage": "الانتقال إلى الصفحة السابقة",
    "accessibility.nextPage": "الانتقال إلى الصفحة التالية",
    "accessibility.morePages": "صفحات إضافية",
    "accessibility.more": "المزيد",
    "search.term.luxurySuv": "سيارة SUV فاخرة",
    "search.term.sportsCar": "سيارة رياضية",
    "search.term.dubaiMarinaRentals": "إيجارات دبي مارينا",
    "search.term.weddingCars": "سيارات الزفاف",
    "search.term.monthlyRentalDeals": "عروض الإيجار الشهري",
    "search.term.chauffeurService": "خدمة سائق",
    "search.type.location": "موقع",
    "search.type.occasion": "مناسبة",
    "search.type.offer": "عرض",
    "search.type.service": "خدمة",
    "categoryPage.notFound": "الفئة غير موجودة",
    "categoryPage.empty": "لا توجد {category} متاحة حالياً. تحقق مرة أخرى قريباً!",
    "categoryPage.rent": "استئجار {name}",
    "categoryPage.available": "{name} المتاحة",
    "brandPage.notFound": "العلامة التجارية غير موجودة",
    "brandPage.descriptionFallback": "اكتشف مجموعتنا المميزة من سيارات {brand} للإيجار في الإمارات.",
    "brandPage.availableCars": "سيارات {brand} المتاحة",
    "brandPage.empty": "لا توجد سيارات {brand} متاحة حالياً. تحقق مرة أخرى قريباً!",
    "cityPage.notFound": "المدينة غير موجودة",
    "cityPage.rentalIn": "تأجير سيارات في {city}",
    "cityPage.availableCarsIn": "السيارات المتاحة في {city}",
    "cityPage.empty": "لا توجد سيارات متاحة في {city} حالياً. تحقق مرة أخرى قريباً!",
    "supplierPage.notFound": "المورّد غير موجود",
    "supplierPage.whatsappPrefill": "مرحباً! أنا مهتم باستئجار سيارة من {supplier}.",
    "supplierPage.feature.airportTransfer": "نقل من وإلى المطار",
    "supplierPage.feature.flexiblePayment": "خيارات دفع مرنة",
    "supplierPage.feature.multiLanguageSupport": "دعم متعدد اللغات",
    "supplierPage.descriptionFallback": "خدمة تأجير سيارات مميزة في {city}.",
    "supplierPage.reviewCount": "({count} مراجعات)",
    "supplierPage.carsFrom": "سيارات من {supplier}",
    "supplierPage.empty": "لا توجد سيارات مدرجة لهذا المورّد حالياً.",
    "booking.step.details": "التفاصيل",
    "booking.step.extras": "الإضافات",
    "booking.step.payment": "الدفع",
    "booking.step.confirmation": "التأكيد",
    "booking.loadCarError": "فشل في تحميل تفاصيل السيارة",
    "booking.failed": "فشل في إنشاء الحجز",
    "booking.selectPickupReturn": "يرجى اختيار تاريخي الاستلام والتسليم",
    "booking.fillContactDetails": "يرجى تعبئة جميع بيانات التواصل",
    "booking.loginRequired": "يرجى تسجيل الدخول لإكمال الحجز",
    "booking.createdSuccess": "تم إنشاء الحجز بنجاح!",
    "booking.notFound": "السيارة غير موجودة",
    "booking.bookYour": "احجز {car}",
    "booking.detailsTitle": "تفاصيل الحجز",
    "booking.pickupDateTime": "تاريخ ووقت الاستلام",
    "booking.returnDateTime": "تاريخ ووقت التسليم",
    "booking.pickupLocation": "موقع الاستلام",
    "booking.returnLocation": "موقع التسليم",
    "booking.pickupLocationPlaceholder": "فندق، مطار، إلخ.",
    "booking.returnLocationPlaceholder": "نفس موقع الاستلام",
    "booking.contactInformation": "معلومات التواصل",
    "booking.fullName": "الاسم الكامل",
    "booking.phone": "الهاتف",
    "booking.driverAge": "عمر السائق",
    "booking.driverAgePlaceholder": "الحد الأدنى 25",
    "booking.continueToExtras": "المتابعة إلى الإضافات",
    "booking.optionalExtras": "إضافات اختيارية",
    "booking.extraDriver": "سائق إضافي",
    "booking.extraDriverDesc": "إضافة سائق آخر",
    "booking.childSeat": "مقعد طفل",
    "booking.childSeatDesc": "مقعد سيارة للرضيع/الطفل",
    "booking.gpsNavigation": "نظام ملاحة GPS",
    "booking.gpsNavigationDesc": "نظام ملاحة داخل السيارة",
    "booking.premiumInsurance": "تأمين مميز",
    "booking.premiumInsuranceDesc": "تغطية كاملة بدون تحمّل",
    "booking.continueToPayment": "المتابعة إلى الدفع",
    "booking.loginToContinue": "يرجى تسجيل الدخول للمتابعة",
    "booking.loginRequiredDescription": "يجب أن تكون مسجلاً للدخول لإكمال حجزك",
    "booking.loginRegister": "تسجيل الدخول / إنشاء حساب",
    "booking.securePaymentDescription": "تتم معالجة دفعتك بأمان. نحن نقبل جميع بطاقات الائتمان والخصم الرئيسية.",
    "booking.paymentPlaceholder": "سيظهر نموذج الدفع هنا (تكامل Stripe)",
    "booking.confirmAndPay": "تأكيد والدفع",
    "booking.confirmedTitle": "تم تأكيد الحجز!",
    "booking.referenceLabel": "مرجع الحجز الخاص بك هو:",
    "booking.confirmationEmailSent": "تم إرسال رسالة تأكيد إلى {email}",
    "booking.viewMyBookings": "عرض حجوزاتي",
    "booking.browseMoreCars": "تصفح المزيد من السيارات",
    "booking.summary": "ملخص الحجز",
    "booking.extrasLabel": "الإضافات",
    "booking.discount": "الخصم",
    "booking.securityDepositNotice": "سيتم حجز مبلغ {amount} على بطاقتك وإعادته بعد التسليم.",
    "booking.daysCount": "{count} أيام",
    "booking.basis.daily": "يومي",
    "booking.basis.weekly": "أسبوعي",
    "booking.basis.monthly": "شهري",
    "faq.helpCenter": "مركز المساعدة",
    "faq.metaTitle": "الأسئلة الشائعة | أكثر الأسئلة شيوعاً حول تأجير السيارات",
    "faq.subtitle": "اعثر على إجابات للأسئلة الشائعة حول خدمات تأجير السيارات لدينا.",
    "faq.allQuestions": "كل الأسئلة",
    "faq.noMatch": "لم يتم العثور على أسئلة تطابق بحثك.",
    "faq.clearSearch": "مسح البحث",
    "faq.stillHaveQuestions": "هل ما زالت لديك أسئلة؟",
    "faq.supportDescription": "لم تجد ما تبحث عنه؟ فريق الدعم لدينا هنا للمساعدة.",
    "faq.chatWhatsApp": "الدردشة عبر واتساب",
    "faq.category.bookingReservations": "الحجز والحجوزات",
    "faq.question.howBook": "كيف يمكنني حجز سيارة؟",
    "faq.answer.howBook": "حجز السيارة سهل! ما عليك سوى تصفح مجموعتنا واختيار السيارة المناسبة والتواصل معنا عبر واتساب أو الهاتف أو نموذج الاستفسار.",
    "faq.question.advanceBooking": "كم من الوقت مسبقاً يجب أن أحجز؟",
    "faq.answer.advanceBooking": "نوصي بالحجز قبل 24 إلى 48 ساعة على الأقل، خاصةً للسيارات الفاخرة.",
    "about.title": "من نحن",
    "about.metaTitle": "من نحن | خدمة تأجير السيارات الفاخرة الرائدة في الإمارات",
    "about.storyEyebrow": "قصتنا",
    "about.storyTitle": "إعادة تعريف تأجير السيارات الفاخرة في الإمارات",
    "about.storySubtitle": "منذ 2014 ونحن نقدم تجارب استثنائية في تأجير السيارات.",
    "about.whoWeAreEyebrow": "من نحن",
    "about.legacyTitle": "إرث من التميز",
    "about.legacyContent": "تأسست Velaris Royal Car Rental برؤية تهدف إلى تغيير تجربة تأجير السيارات في الإمارات. وما بدأ كأسطول صغير من السيارات الفاخرة أصبح أحد أكثر الأسماء الموثوقة في مجال تأجير السيارات الفاخرة في المنطقة.\n\nويمتد التزامنا بالتميز إلى ما هو أبعد من توفير السيارات فقط. فنحن نقدم تجربة فاخرة متكاملة من لحظة تصفح مجموعتنا وحتى إعادة المفاتيح.\n\nواليوم نتعاون مع أكثر من 150 مورداً مميزاً، ما يتيح الوصول إلى أكثر من 1,200 سيارة عبر جميع الإمارات.",
    "about.valuesEyebrow": "قيمنا",
    "about.valuesTitle": "ما الذي يقودنا",
    "about.ctaTitle": "هل أنت مستعد لتجربة خدمة ملكية؟",
    "about.heroAlt": "سيارات فاخرة",
    "about.stat.yearsExperience": "سنوات الخبرة",
    "about.stat.premiumVehicles": "سيارات مميزة",
    "about.feature.excellence.title": "التميّز",
    "about.feature.excellence.description": "نسعى إلى التميّز في كل جانب من جوانب خدمتنا.",
    "about.feature.customerFirst.title": "العميل أولاً",
    "about.feature.customerFirst.description": "رضاك هو أولويتنا.",
    "about.feature.premiumFleet.title": "أسطول مميز",
    "about.feature.premiumFleet.description": "لا ينضم إلى مجموعتنا سوى أفضل السيارات.",
    "about.feature.trustSafety.title": "الثقة والأمان",
    "about.feature.trustSafety.description": "تأمين شامل ودعم على مدار الساعة.",
    "about.storyImageAlt": "سيارة فاخرة",
    "about.yearsOfExcellence": "سنوات من التميّز",
    "auth.exampleEmail": "you@example.com",
    "auth.exampleName": "الاسم الكامل",
    "contact.exampleTitle": "استفسار عن إيجار نهاية الأسبوع",
    "contact.locationTitle": "موقع Velaris Royal",
    "footer.googlePlayAlt": "حمّله من Google Play",
    "footer.appStoreAlt": "نزّله من App Store"
  },
  fr: {
    "common.brands": "Marques",
    "common.cities": "Villes",
    "common.suppliers": "Fournisseurs",
    "common.support": "Assistance",
    "common.available": "Disponibles",
    "common.booking": "Réservation",
    "common.payment": "Paiement",
    "common.confirmation": "Confirmation",
    "common.details": "Détails",
    "common.extras": "Options",
    "common.back": "Retour",
    "common.previous": "Précédent",
    "common.next": "Suivant",
    "common.close": "Fermer",
    "common.verified": "Vérifié",
    "common.contactSupplier": "Contacter le fournisseur",
    "common.securePayment": "Paiement sécurisé",
    "common.refreshingPricing": "Actualisation des tarifs...",
    "common.securityDeposit": "Dépôt de garantie",
    "common.pickup": "Prise en charge",
    "common.return": "Retour",
    "common.uae": "EAU",
    "accessibility.zoomOut": "Zoom arrière",
    "accessibility.zoomIn": "Zoom avant",
    "accessibility.switchToLightMode": "Passer au mode clair",
    "accessibility.switchToDarkMode": "Passer au mode sombre",
    "accessibility.logoAlt": "Location de voitures Velaris Royal",
    "accessibility.locationMap": "Emplacement Velaris Royal",
    "accessibility.breadcrumb": "Fil d’Ariane",
    "accessibility.previousSlide": "Diapositive précédente",
    "accessibility.nextSlide": "Diapositive suivante",
    "accessibility.pagination": "Pagination",
    "accessibility.previousPage": "Aller à la page précédente",
    "accessibility.nextPage": "Aller à la page suivante",
    "accessibility.morePages": "Plus de pages",
    "accessibility.more": "Plus",
    "search.term.luxurySuv": "SUV de luxe",
    "search.term.sportsCar": "Voiture de sport",
    "search.term.dubaiMarinaRentals": "Locations Dubai Marina",
    "search.term.weddingCars": "Voitures de mariage",
    "search.term.monthlyRentalDeals": "Offres de location mensuelle",
    "search.term.chauffeurService": "Service chauffeur",
    "search.type.location": "Lieu",
    "search.type.occasion": "Occasion",
    "search.type.offer": "Offre",
    "search.type.service": "Service",
    "categoryPage.notFound": "Catégorie introuvable",
    "categoryPage.empty": "Aucune {category} disponible pour le moment. Revenez bientôt !",
    "categoryPage.rent": "Louer {name}",
    "categoryPage.available": "{name} disponibles",
    "brandPage.notFound": "Marque introuvable",
    "brandPage.descriptionFallback": "Découvrez notre collection premium de {brand} à louer aux EAU.",
    "brandPage.availableCars": "Voitures {brand} disponibles",
    "brandPage.empty": "Aucune voiture {brand} disponible pour le moment. Revenez bientôt !",
    "cityPage.notFound": "Ville introuvable",
    "cityPage.rentalIn": "Location de voiture à {city}",
    "cityPage.availableCarsIn": "Voitures disponibles à {city}",
    "cityPage.empty": "Aucune voiture disponible à {city} pour le moment. Revenez bientôt !",
    "supplierPage.notFound": "Fournisseur introuvable",
    "supplierPage.whatsappPrefill": "Bonjour ! Je suis intéressé par une location de voiture chez {supplier}.",
    "supplierPage.feature.airportTransfer": "Transfert aéroport",
    "supplierPage.feature.flexiblePayment": "Options de paiement flexibles",
    "supplierPage.feature.multiLanguageSupport": "Support multilingue",
    "supplierPage.descriptionFallback": "Service premium de location de voitures à {city}.",
    "supplierPage.reviewCount": "({count} avis)",
    "supplierPage.carsFrom": "Voitures de {supplier}",
    "supplierPage.empty": "Aucune voiture n’est actuellement proposée par ce fournisseur.",
    "booking.step.details": "Détails",
    "booking.step.extras": "Options",
    "booking.step.payment": "Paiement",
    "booking.step.confirmation": "Confirmation",
    "booking.loadCarError": "Impossible de charger les détails du véhicule",
    "booking.failed": "Échec de la création de la réservation",
    "booking.selectPickupReturn": "Veuillez sélectionner les dates de prise en charge et de retour",
    "booking.fillContactDetails": "Veuillez renseigner toutes les coordonnées",
    "booking.loginRequired": "Veuillez vous connecter pour finaliser la réservation",
    "booking.createdSuccess": "Réservation créée avec succès !",
    "booking.notFound": "Véhicule introuvable",
    "booking.bookYour": "Réservez votre {car}",
    "booking.detailsTitle": "Détails de la réservation",
    "booking.pickupDateTime": "Date et heure de prise en charge",
    "booking.returnDateTime": "Date et heure de retour",
    "booking.pickupLocation": "Lieu de prise en charge",
    "booking.returnLocation": "Lieu de retour",
    "booking.pickupLocationPlaceholder": "Hôtel, aéroport, etc.",
    "booking.returnLocationPlaceholder": "Identique à la prise en charge",
    "booking.contactInformation": "Coordonnées",
    "booking.fullName": "Nom complet",
    "booking.phone": "Téléphone",
    "booking.driverAge": "Âge du conducteur",
    "booking.driverAgePlaceholder": "Minimum 25",
    "booking.continueToExtras": "Continuer vers les options",
    "booking.optionalExtras": "Options facultatives",
    "booking.extraDriver": "Conducteur supplémentaire",
    "booking.extraDriverDesc": "Ajouter un conducteur supplémentaire",
    "booking.childSeat": "Siège enfant",
    "booking.childSeatDesc": "Siège auto bébé/enfant",
    "booking.gpsNavigation": "Navigation GPS",
    "booking.gpsNavigationDesc": "Système de navigation embarqué",
    "booking.premiumInsurance": "Assurance premium",
    "booking.premiumInsuranceDesc": "Couverture complète, franchise zéro",
    "booking.continueToPayment": "Continuer vers le paiement",
    "booking.loginToContinue": "Veuillez vous connecter pour continuer",
    "booking.loginRequiredDescription": "Vous devez être connecté pour finaliser votre réservation",
    "booking.loginRegister": "Connexion / Inscription",
    "booking.securePaymentDescription": "Votre paiement est traité en toute sécurité. Nous acceptons toutes les principales cartes de crédit et de débit.",
    "booking.paymentPlaceholder": "Le formulaire de paiement s’affichera ici (intégration Stripe)",
    "booking.confirmAndPay": "Confirmer et payer",
    "booking.confirmedTitle": "Réservation confirmée !",
    "booking.referenceLabel": "Votre référence de réservation est :",
    "booking.confirmationEmailSent": "Un e-mail de confirmation a été envoyé à {email}",
    "booking.viewMyBookings": "Voir mes réservations",
    "booking.browseMoreCars": "Voir plus de voitures",
    "booking.summary": "Récapitulatif de réservation",
    "booking.extrasLabel": "Options",
    "booking.discount": "Remise",
    "booking.securityDepositNotice": "{amount} sera bloqué sur votre carte et remboursé après le retour.",
    "booking.daysCount": "{count} jours",
    "booking.basis.daily": "par jour",
    "booking.basis.weekly": "par semaine",
    "booking.basis.monthly": "par mois",
    "faq.helpCenter": "Centre d’aide",
    "faq.metaTitle": "FAQ | Questions fréquentes sur la location de voitures",
    "faq.subtitle": "Trouvez des réponses aux questions fréquentes sur nos services de location de voitures.",
    "faq.allQuestions": "Toutes les questions",
    "faq.noMatch": "Aucune question ne correspond à votre recherche.",
    "faq.clearSearch": "Effacer la recherche",
    "faq.stillHaveQuestions": "Vous avez encore des questions ?",
    "faq.supportDescription": "Vous ne trouvez pas ce que vous cherchez ? Notre équipe d’assistance est là pour vous aider.",
    "faq.chatWhatsApp": "Discuter sur WhatsApp",
    "faq.category.bookingReservations": "Réservation et réservations",
    "faq.question.howBook": "Comment réserver une voiture ?",
    "faq.answer.howBook": "Réserver une voiture est simple ! Parcourez notre collection, choisissez votre véhicule préféré et contactez-nous via WhatsApp, téléphone ou formulaire de demande.",
    "faq.question.advanceBooking": "Combien de temps à l’avance dois-je réserver ?",
    "faq.answer.advanceBooking": "Nous recommandons de réserver au moins 24 à 48 heures à l’avance, surtout pour les véhicules de luxe.",
    "about.title": "À propos",
    "about.metaTitle": "À propos | Le premier service de location de voitures de luxe aux Émirats",
    "about.storyEyebrow": "NOTRE HISTOIRE",
    "about.storyTitle": "Redéfinir la location de voitures de luxe aux Émirats",
    "about.storySubtitle": "Depuis 2014, nous offrons des expériences de location exceptionnelles.",
    "about.whoWeAreEyebrow": "QUI SOMMES-NOUS",
    "about.legacyTitle": "Un héritage d'excellence",
    "about.legacyContent": "Velaris Royal Car Rental a été fondée avec la vision de transformer l'expérience de location automobile aux Émirats arabes unis. Ce qui a commencé avec une petite flotte de véhicules de luxe est devenu l'un des noms les plus fiables de la région dans la location premium.\n\nNotre engagement envers l'excellence va bien au-delà des véhicules eux-mêmes. Nous offrons une expérience de luxe complète, depuis la découverte de notre collection jusqu'au retour des clés.\n\nAujourd'hui, nous collaborons avec plus de 150 partenaires premium, donnant accès à plus de 1 200 véhicules dans tous les émirats.",
    "about.valuesEyebrow": "NOS VALEURS",
    "about.valuesTitle": "Ce qui nous anime",
    "about.ctaTitle": "Prêt à vivre un service royal ?",
    "about.heroAlt": "Voitures de luxe",
    "about.stat.yearsExperience": "Années d’expérience",
    "about.stat.premiumVehicles": "Véhicules premium",
    "about.feature.excellence.title": "Excellence",
    "about.feature.excellence.description": "Nous visons l’excellence dans chaque aspect de notre service.",
    "about.feature.customerFirst.title": "Le client d’abord",
    "about.feature.customerFirst.description": "Votre satisfaction est notre priorité.",
    "about.feature.premiumFleet.title": "Flotte premium",
    "about.feature.premiumFleet.description": "Seuls les meilleurs véhicules rejoignent notre collection.",
    "about.feature.trustSafety.title": "Confiance et sécurité",
    "about.feature.trustSafety.description": "Assurance complète et assistance 24h/24 et 7j/7.",
    "about.storyImageAlt": "Voiture de luxe",
    "about.yearsOfExcellence": "Années d’excellence",
    "auth.exampleEmail": "you@example.com",
    "auth.exampleName": "Jean Dupont",
    "contact.exampleTitle": "Question sur une location de week-end",
    "contact.locationTitle": "Emplacement Velaris Royal",
    "footer.googlePlayAlt": "Disponible sur Google Play",
    "footer.appStoreAlt": "Télécharger sur l’App Store"
  },
  de: {
    "common.brands": "Marken",
    "common.cities": "Städte",
    "common.suppliers": "Anbieter",
    "common.support": "Support",
    "common.available": "Verfügbar",
    "common.booking": "Buchung",
    "common.payment": "Zahlung",
    "common.confirmation": "Bestätigung",
    "common.details": "Details",
    "common.extras": "Extras",
    "common.back": "Zurück",
    "common.previous": "Zurück",
    "common.next": "Weiter",
    "common.close": "Schließen",
    "common.verified": "Verifiziert",
    "common.contactSupplier": "Anbieter kontaktieren",
    "common.securePayment": "Sichere Zahlung",
    "common.refreshingPricing": "Preise werden aktualisiert...",
    "common.securityDeposit": "Kaution",
    "common.pickup": "Abholung",
    "common.return": "Rückgabe",
    "common.uae": "VAE",
    "accessibility.zoomOut": "Verkleinern",
    "accessibility.zoomIn": "Vergrößern",
    "accessibility.switchToLightMode": "Zum hellen Modus wechseln",
    "accessibility.switchToDarkMode": "Zum dunklen Modus wechseln",
    "accessibility.logoAlt": "Velaris Royal Autovermietung",
    "accessibility.locationMap": "Standort von Velaris Royal",
    "accessibility.breadcrumb": "Brotkrumen-Navigation",
    "accessibility.previousSlide": "Vorherige Folie",
    "accessibility.nextSlide": "Nächste Folie",
    "accessibility.pagination": "Seitennavigation",
    "accessibility.previousPage": "Zur vorherigen Seite",
    "accessibility.nextPage": "Zur nächsten Seite",
    "accessibility.morePages": "Weitere Seiten",
    "accessibility.more": "Mehr",
    "search.term.luxurySuv": "Luxus-SUV",
    "search.term.sportsCar": "Sportwagen",
    "search.term.dubaiMarinaRentals": "Mieten in Dubai Marina",
    "search.term.weddingCars": "Hochzeitsautos",
    "search.term.monthlyRentalDeals": "Monatliche Mietangebote",
    "search.term.chauffeurService": "Chauffeurservice",
    "search.type.location": "Ort",
    "search.type.occasion": "Anlass",
    "search.type.offer": "Angebot",
    "search.type.service": "Service",
    "categoryPage.notFound": "Kategorie nicht gefunden",
    "categoryPage.empty": "Derzeit sind keine {category} verfügbar. Bitte später erneut prüfen!",
    "categoryPage.rent": "{name} mieten",
    "categoryPage.available": "Verfügbare {name}",
    "brandPage.notFound": "Marke nicht gefunden",
    "brandPage.descriptionFallback": "Entdecken Sie unsere Premium-{brand}-Kollektion zur Miete in den VAE.",
    "brandPage.availableCars": "Verfügbare {brand} Fahrzeuge",
    "brandPage.empty": "Derzeit sind keine {brand} Fahrzeuge verfügbar. Bitte später erneut prüfen!",
    "cityPage.notFound": "Stadt nicht gefunden",
    "cityPage.rentalIn": "Autovermietung in {city}",
    "cityPage.availableCarsIn": "Verfügbare Fahrzeuge in {city}",
    "cityPage.empty": "Derzeit sind in {city} keine Fahrzeuge verfügbar. Bitte später erneut prüfen!",
    "supplierPage.notFound": "Anbieter nicht gefunden",
    "supplierPage.whatsappPrefill": "Hallo! Ich interessiere mich für eine Fahrzeugmiete bei {supplier}.",
    "supplierPage.feature.airportTransfer": "Flughafentransfer",
    "supplierPage.feature.flexiblePayment": "Flexible Zahlungsoptionen",
    "supplierPage.feature.multiLanguageSupport": "Mehrsprachiger Support",
    "supplierPage.descriptionFallback": "Premium-Autovermietung in {city}.",
    "supplierPage.reviewCount": "({count} Bewertungen)",
    "supplierPage.carsFrom": "Fahrzeuge von {supplier}",
    "supplierPage.empty": "Dieser Anbieter hat derzeit keine Fahrzeuge gelistet.",
    "booking.step.details": "Details",
    "booking.step.extras": "Extras",
    "booking.step.payment": "Zahlung",
    "booking.step.confirmation": "Bestätigung",
    "booking.loadCarError": "Fahrzeugdetails konnten nicht geladen werden",
    "booking.failed": "Buchung konnte nicht erstellt werden",
    "booking.selectPickupReturn": "Bitte wählen Sie Abhol- und Rückgabedatum aus",
    "booking.fillContactDetails": "Bitte füllen Sie alle Kontaktdaten aus",
    "booking.loginRequired": "Bitte melden Sie sich an, um die Buchung abzuschließen",
    "booking.createdSuccess": "Buchung erfolgreich erstellt!",
    "booking.notFound": "Fahrzeug nicht gefunden",
    "booking.bookYour": "Buchen Sie Ihren {car}",
    "booking.detailsTitle": "Buchungsdetails",
    "booking.pickupDateTime": "Datum und Uhrzeit der Abholung",
    "booking.returnDateTime": "Datum und Uhrzeit der Rückgabe",
    "booking.pickupLocation": "Abholort",
    "booking.returnLocation": "Rückgabeort",
    "booking.pickupLocationPlaceholder": "Hotel, Flughafen usw.",
    "booking.returnLocationPlaceholder": "Wie Abholort",
    "booking.contactInformation": "Kontaktinformationen",
    "booking.fullName": "Vollständiger Name",
    "booking.phone": "Telefon",
    "booking.driverAge": "Alter des Fahrers",
    "booking.driverAgePlaceholder": "Mindestens 25",
    "booking.continueToExtras": "Weiter zu Extras",
    "booking.optionalExtras": "Optionale Extras",
    "booking.extraDriver": "Zusätzlicher Fahrer",
    "booking.extraDriverDesc": "Einen weiteren Fahrer hinzufügen",
    "booking.childSeat": "Kindersitz",
    "booking.childSeatDesc": "Auto-Kindersitz für Baby/Kleinkind",
    "booking.gpsNavigation": "GPS-Navigation",
    "booking.gpsNavigationDesc": "Navigationssystem im Fahrzeug",
    "booking.premiumInsurance": "Premium-Versicherung",
    "booking.premiumInsuranceDesc": "Vollschutz ohne Selbstbeteiligung",
    "booking.continueToPayment": "Weiter zur Zahlung",
    "booking.loginToContinue": "Bitte melden Sie sich an, um fortzufahren",
    "booking.loginRequiredDescription": "Sie müssen angemeldet sein, um Ihre Buchung abzuschließen",
    "booking.loginRegister": "Anmelden / Registrieren",
    "booking.securePaymentDescription": "Ihre Zahlung wird sicher verarbeitet. Wir akzeptieren alle gängigen Kredit- und Debitkarten.",
    "booking.paymentPlaceholder": "Das Zahlungsformular wird hier angezeigt (Stripe-Integration)",
    "booking.confirmAndPay": "Bestätigen & bezahlen",
    "booking.confirmedTitle": "Buchung bestätigt!",
    "booking.referenceLabel": "Ihre Buchungsreferenz lautet:",
    "booking.confirmationEmailSent": "Eine Bestätigungs-E-Mail wurde an {email} gesendet",
    "booking.viewMyBookings": "Meine Buchungen ansehen",
    "booking.browseMoreCars": "Weitere Fahrzeuge durchsuchen",
    "booking.summary": "Buchungsübersicht",
    "booking.extrasLabel": "Extras",
    "booking.discount": "Rabatt",
    "booking.securityDepositNotice": "{amount} wird auf Ihrer Karte blockiert und nach der Rückgabe erstattet.",
    "booking.daysCount": "{count} Tage",
    "booking.basis.daily": "täglich",
    "booking.basis.weekly": "wöchentlich",
    "booking.basis.monthly": "monatlich",
    "faq.helpCenter": "Hilfecenter",
    "faq.metaTitle": "FAQ | Häufig gestellte Fragen zur Autovermietung",
    "faq.subtitle": "Finden Sie Antworten auf häufige Fragen zu unseren Autovermietungsdiensten.",
    "faq.allQuestions": "Alle Fragen",
    "faq.noMatch": "Keine Fragen passend zu Ihrer Suche gefunden.",
    "faq.clearSearch": "Suche löschen",
    "faq.stillHaveQuestions": "Haben Sie noch Fragen?",
    "faq.supportDescription": "Sie finden nicht, wonach Sie suchen? Unser Support-Team hilft Ihnen gerne weiter.",
    "faq.chatWhatsApp": "Auf WhatsApp chatten",
    "faq.category.bookingReservations": "Buchung & Reservierungen",
    "faq.question.howBook": "Wie buche ich ein Auto?",
    "faq.answer.howBook": "Ein Auto zu buchen ist ganz einfach! Durchsuchen Sie unsere Auswahl, wählen Sie Ihr gewünschtes Fahrzeug und kontaktieren Sie uns per WhatsApp, Telefon oder Anfrageformular.",
    "faq.question.advanceBooking": "Wie weit im Voraus sollte ich buchen?",
    "faq.answer.advanceBooking": "Wir empfehlen eine Buchung mindestens 24 bis 48 Stunden im Voraus, besonders bei Luxusfahrzeugen.",
    "about.title": "Über uns",
    "about.metaTitle": "Über uns | Führender Luxus-Autovermietungsservice in den VAE",
    "about.storyEyebrow": "UNSERE GESCHICHTE",
    "about.storyTitle": "Luxus-Autovermietung in den VAE neu definiert",
    "about.storySubtitle": "Seit 2014 bieten wir außergewöhnliche Mietwagenerlebnisse.",
    "about.whoWeAreEyebrow": "WER WIR SIND",
    "about.legacyTitle": "Ein Vermächtnis der Exzellenz",
    "about.legacyContent": "Velaris Royal Car Rental wurde mit der Vision gegründet, das Mietwagenerlebnis in den VAE zu verändern. Was als kleine Flotte luxuriöser Fahrzeuge begann, ist zu einem der vertrauenswürdigsten Namen der Region im Premium-Car-Hire geworden.\n\nUnser Anspruch an Exzellenz geht weit über die Fahrzeuge hinaus. Wir bieten ein umfassendes Luxuserlebnis – vom ersten Blick auf unsere Kollektion bis zur Rückgabe der Schlüssel.\n\nHeute arbeiten wir mit über 150 Premium-Anbietern zusammen und bieten Zugang zu mehr als 1.200 Fahrzeugen in allen Emiraten.",
    "about.valuesEyebrow": "UNSERE WERTE",
    "about.valuesTitle": "Was uns antreibt",
    "about.ctaTitle": "Bereit für königlichen Service?",
    "about.heroAlt": "Luxusfahrzeuge",
    "about.stat.yearsExperience": "Jahre Erfahrung",
    "about.stat.premiumVehicles": "Premium-Fahrzeuge",
    "about.feature.excellence.title": "Exzellenz",
    "about.feature.excellence.description": "Wir streben in jedem Bereich unseres Services nach Exzellenz.",
    "about.feature.customerFirst.title": "Kunde zuerst",
    "about.feature.customerFirst.description": "Ihre Zufriedenheit hat für uns oberste Priorität.",
    "about.feature.premiumFleet.title": "Premium-Flotte",
    "about.feature.premiumFleet.description": "Nur die besten Fahrzeuge schaffen es in unsere Kollektion.",
    "about.feature.trustSafety.title": "Vertrauen & Sicherheit",
    "about.feature.trustSafety.description": "Umfassender Versicherungsschutz und 24/7-Support.",
    "about.storyImageAlt": "Luxusauto",
    "about.yearsOfExcellence": "Jahre der Exzellenz",
    "auth.exampleEmail": "you@example.com",
    "auth.exampleName": "Max Mustermann",
    "contact.exampleTitle": "Frage zur Wochenendmiete",
    "contact.locationTitle": "Standort von Velaris Royal",
    "footer.googlePlayAlt": "Bei Google Play erhältlich",
    "footer.appStoreAlt": "Im App Store laden"
  },
  ru: {
    "common.brands": "Бренды",
    "common.cities": "Города",
    "common.suppliers": "Поставщики",
    "common.support": "Поддержка",
    "common.available": "Доступно",
    "common.booking": "Бронирование",
    "common.payment": "Оплата",
    "common.confirmation": "Подтверждение",
    "common.details": "Детали",
    "common.extras": "Дополнения",
    "common.back": "Назад",
    "common.previous": "Назад",
    "common.next": "Далее",
    "common.close": "Закрыть",
    "common.verified": "Проверено",
    "common.contactSupplier": "Связаться с поставщиком",
    "common.securePayment": "Безопасная оплата",
    "common.refreshingPricing": "Обновление цен...",
    "common.securityDeposit": "Гарантийный депозит",
    "common.pickup": "Получение",
    "common.return": "Возврат",
    "common.uae": "ОАЭ",
    "accessibility.zoomOut": "Уменьшить",
    "accessibility.zoomIn": "Увеличить",
    "accessibility.switchToLightMode": "Переключиться на светлую тему",
    "accessibility.switchToDarkMode": "Переключиться на тёмную тему",
    "accessibility.logoAlt": "Прокат автомобилей Velaris Royal",
    "accessibility.locationMap": "Расположение Velaris Royal",
    "accessibility.breadcrumb": "Навигационная цепочка",
    "accessibility.previousSlide": "Предыдущий слайд",
    "accessibility.nextSlide": "Следующий слайд",
    "accessibility.pagination": "Пагинация",
    "accessibility.previousPage": "Перейти на предыдущую страницу",
    "accessibility.nextPage": "Перейти на следующую страницу",
    "accessibility.morePages": "Больше страниц",
    "accessibility.more": "Ещё",
    "search.term.luxurySuv": "Роскошный SUV",
    "search.term.sportsCar": "Спортивный автомобиль",
    "search.term.dubaiMarinaRentals": "Аренда в Dubai Marina",
    "search.term.weddingCars": "Свадебные автомобили",
    "search.term.monthlyRentalDeals": "Месячные предложения аренды",
    "search.term.chauffeurService": "Услуга шофёра",
    "search.type.location": "Локация",
    "search.type.occasion": "Событие",
    "search.type.offer": "Предложение",
    "search.type.service": "Сервис",
    "categoryPage.notFound": "Категория не найдена",
    "categoryPage.empty": "Сейчас нет доступных {category}. Загляните позже!",
    "categoryPage.rent": "Аренда {name}",
    "categoryPage.available": "Доступные {name}",
    "brandPage.notFound": "Бренд не найден",
    "brandPage.descriptionFallback": "Откройте для себя нашу премиальную коллекцию {brand} для аренды в ОАЭ.",
    "brandPage.availableCars": "Доступные автомобили {brand}",
    "brandPage.empty": "Сейчас нет доступных автомобилей {brand}. Загляните позже!",
    "cityPage.notFound": "Город не найден",
    "cityPage.rentalIn": "Прокат автомобилей в {city}",
    "cityPage.availableCarsIn": "Доступные автомобили в {city}",
    "cityPage.empty": "Сейчас в {city} нет доступных автомобилей. Загляните позже!",
    "supplierPage.notFound": "Поставщик не найден",
    "supplierPage.whatsappPrefill": "Здравствуйте! Меня интересует аренда автомобиля у {supplier}.",
    "supplierPage.feature.airportTransfer": "Трансфер из аэропорта",
    "supplierPage.feature.flexiblePayment": "Гибкие варианты оплаты",
    "supplierPage.feature.multiLanguageSupport": "Многоязычная поддержка",
    "supplierPage.descriptionFallback": "Премиальный сервис проката автомобилей в {city}.",
    "supplierPage.reviewCount": "({count} отзывов)",
    "supplierPage.carsFrom": "Автомобили от {supplier}",
    "supplierPage.empty": "Сейчас у этого поставщика нет доступных автомобилей.",
    "booking.step.details": "Детали",
    "booking.step.extras": "Дополнения",
    "booking.step.payment": "Оплата",
    "booking.step.confirmation": "Подтверждение",
    "booking.loadCarError": "Не удалось загрузить данные автомобиля",
    "booking.failed": "Не удалось создать бронирование",
    "booking.selectPickupReturn": "Пожалуйста, выберите даты получения и возврата",
    "booking.fillContactDetails": "Пожалуйста, заполните все контактные данные",
    "booking.loginRequired": "Пожалуйста, войдите, чтобы завершить бронирование",
    "booking.createdSuccess": "Бронирование успешно создано!",
    "booking.notFound": "Автомобиль не найден",
    "booking.bookYour": "Забронируйте {car}",
    "booking.detailsTitle": "Детали бронирования",
    "booking.pickupDateTime": "Дата и время получения",
    "booking.returnDateTime": "Дата и время возврата",
    "booking.pickupLocation": "Место получения",
    "booking.returnLocation": "Место возврата",
    "booking.pickupLocationPlaceholder": "Отель, аэропорт и т. д.",
    "booking.returnLocationPlaceholder": "Как место получения",
    "booking.contactInformation": "Контактная информация",
    "booking.fullName": "Полное имя",
    "booking.phone": "Телефон",
    "booking.driverAge": "Возраст водителя",
    "booking.driverAgePlaceholder": "Минимум 25",
    "booking.continueToExtras": "Перейти к дополнениям",
    "booking.optionalExtras": "Дополнительные опции",
    "booking.extraDriver": "Дополнительный водитель",
    "booking.extraDriverDesc": "Добавить ещё одного водителя",
    "booking.childSeat": "Детское кресло",
    "booking.childSeatDesc": "Автокресло для ребёнка",
    "booking.gpsNavigation": "GPS-навигация",
    "booking.gpsNavigationDesc": "Навигационная система в автомобиле",
    "booking.premiumInsurance": "Премиум-страховка",
    "booking.premiumInsuranceDesc": "Полное покрытие без франшизы",
    "booking.continueToPayment": "Перейти к оплате",
    "booking.loginToContinue": "Пожалуйста, войдите, чтобы продолжить",
    "booking.loginRequiredDescription": "Вы должны войти в систему, чтобы завершить бронирование",
    "booking.loginRegister": "Войти / Зарегистрироваться",
    "booking.securePaymentDescription": "Ваш платёж обрабатывается безопасно. Мы принимаем все основные кредитные и дебетовые карты.",
    "booking.paymentPlaceholder": "Здесь будет отображаться форма оплаты (интеграция Stripe)",
    "booking.confirmAndPay": "Подтвердить и оплатить",
    "booking.confirmedTitle": "Бронирование подтверждено!",
    "booking.referenceLabel": "Ваш номер бронирования:",
    "booking.confirmationEmailSent": "Письмо с подтверждением отправлено на {email}",
    "booking.viewMyBookings": "Мои бронирования",
    "booking.browseMoreCars": "Посмотреть ещё автомобили",
    "booking.summary": "Сводка бронирования",
    "booking.extrasLabel": "Дополнения",
    "booking.discount": "Скидка",
    "booking.securityDepositNotice": "Сумма {amount} будет заблокирована на вашей карте и возвращена после возврата автомобиля.",
    "booking.daysCount": "{count} дн.",
    "booking.basis.daily": "в день",
    "booking.basis.weekly": "в неделю",
    "booking.basis.monthly": "в месяц",
    "faq.helpCenter": "Центр помощи",
    "faq.metaTitle": "FAQ | Часто задаваемые вопросы об аренде автомобилей",
    "faq.subtitle": "Найдите ответы на частые вопросы о наших услугах аренды автомобилей.",
    "faq.allQuestions": "Все вопросы",
    "faq.noMatch": "По вашему запросу вопросы не найдены.",
    "faq.clearSearch": "Очистить поиск",
    "faq.stillHaveQuestions": "Остались вопросы?",
    "faq.supportDescription": "Не нашли то, что искали? Наша служба поддержки готова помочь.",
    "faq.chatWhatsApp": "Написать в WhatsApp",
    "faq.category.bookingReservations": "Бронирование и резервации",
    "faq.question.howBook": "Как забронировать автомобиль?",
    "faq.answer.howBook": "Забронировать автомобиль очень просто! Просмотрите нашу коллекцию, выберите подходящий автомобиль и свяжитесь с нами через WhatsApp, телефон или форму запроса.",
    "faq.question.advanceBooking": "За сколько времени лучше бронировать?",
    "faq.answer.advanceBooking": "Мы рекомендуем бронировать как минимум за 24–48 часов, особенно если речь идёт о роскошных автомобилях.",
    "about.title": "О нас",
    "about.metaTitle": "О нас | Ведущий сервис аренды люксовых автомобилей в ОАЭ",
    "about.storyEyebrow": "НАША ИСТОРИЯ",
    "about.storyTitle": "Новый взгляд на аренду премиальных автомобилей в ОАЭ",
    "about.storySubtitle": "С 2014 года мы создаём исключительный опыт аренды автомобилей.",
    "about.whoWeAreEyebrow": "КТО МЫ",
    "about.legacyTitle": "Наследие совершенства",
    "about.legacyContent": "Velaris Royal Car Rental была основана с целью изменить опыт аренды автомобилей в ОАЭ. То, что начиналось как небольшой парк люксовых машин, превратилось в один из самых надёжных брендов региона в сфере премиальной аренды.\n\nНаше стремление к совершенству выходит далеко за рамки самих автомобилей. Мы предлагаем полный премиальный опыт — от знакомства с нашей коллекцией до момента возврата ключей.\n\nСегодня мы сотрудничаем более чем со 150 премиальными поставщиками и предлагаем доступ к более чем 1 200 автомобилям по всем эмиратам.",
    "about.valuesEyebrow": "НАШИ ЦЕННОСТИ",
    "about.valuesTitle": "Что нами движет",
    "about.ctaTitle": "Готовы испытать королевский сервис?",
    "about.heroAlt": "Роскошные автомобили",
    "about.stat.yearsExperience": "Лет опыта",
    "about.stat.premiumVehicles": "Премиальные автомобили",
    "about.feature.excellence.title": "Высокий стандарт",
    "about.feature.excellence.description": "Мы стремимся к высокому стандарту во всех аспектах нашего сервиса.",
    "about.feature.customerFirst.title": "Клиент прежде всего",
    "about.feature.customerFirst.description": "Ваше удовлетворение — наш приоритет.",
    "about.feature.premiumFleet.title": "Премиальный автопарк",
    "about.feature.premiumFleet.description": "В нашу коллекцию попадают только лучшие автомобили.",
    "about.feature.trustSafety.title": "Надёжность и безопасность",
    "about.feature.trustSafety.description": "Полная страховка и поддержка 24/7.",
    "about.storyImageAlt": "Роскошный автомобиль",
    "about.yearsOfExcellence": "Годы совершенства",
    "auth.exampleEmail": "you@example.com",
    "auth.exampleName": "Иван Иванов",
    "contact.exampleTitle": "Вопрос по аренде на выходные",
    "contact.locationTitle": "Расположение Velaris Royal",
    "footer.googlePlayAlt": "Доступно в Google Play",
    "footer.appStoreAlt": "Скачать в App Store"
  },
};
